// extracted by mini-css-extract-plugin
export default {"blogRiver":"blog-river__blogRiver--2-Wjj"};
    if(module.hot) {
      // 1792682147234
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  